import api from "../api";
import { AdminDashboardSummaryResponse, RegistrationsEvolutionResponse } from "../response/admin-dashboard";

export const ADMIN_DASHBOARD_ENDPOINTS = {
  REGISTRATIONS_EVOLUTION: "/v1/admin/dashboard/registrations-evolution",
  SUMMARY: "/v1/admin/dashboard/summary",
};

export const AdminDashboardService = {
  registrationsEvolution: async (): Promise<RegistrationsEvolutionResponse> => {
    const response = await api.get(ADMIN_DASHBOARD_ENDPOINTS.REGISTRATIONS_EVOLUTION);
    return response.data;
  },
  summary: async (): Promise<AdminDashboardSummaryResponse> => {
    const response = await api.get(ADMIN_DASHBOARD_ENDPOINTS.SUMMARY);
    return response.data;
  },
};
